import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';

const Animation = styled.div`
  @keyframes loader {
    0% {
      transform: scaleY(0.5);
      opacity: 0.5;
    }
    50% {
      transform: scaleY(1);
      opacity: 1;
    }
    100% {
      transform: scaleY(0.5);
      opacity: 0.5;
    }
  }

  animation-name: loader;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-delay: ${props => (props.delay)};
`;

const MsLoader = ({ size, theme, color }) => {
  const loaderColor = color || (theme && theme.loaderColor);
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <Animation loaderColor={loaderColor} delay="0">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width={size}
          height={1.5 * size}
          viewBox="0 0 16 30"
          enableBackground="new 0 0 50 50"
        >
          <rect
            x="3"
            y="1"
            width="10"
            height="28"
            fill={loaderColor}
            stroke={loaderColor}
          />
        </svg>
      </Animation>
      <Animation loaderColor={loaderColor} delay="125ms">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width={size}
          height={1.5 * size}
          viewBox="0 0 16 30"
          enableBackground="new 0 0 50 50"
        >
          <rect
            x="3"
            y="1"
            width="10"
            height="28"
            fill={loaderColor}
            stroke={color}
          />
        </svg>
      </Animation>
      <Animation loaderColor={loaderColor} delay="250ms">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width={size}
          height={1.5 * size}
          viewBox="0 0 16 30"
          enableBackground="new 0 0 50 50"
        >
          <rect
            x="3"
            y="1"
            width="10"
            height="28"
            fill={loaderColor}
            stroke={color}
          />
        </svg>
      </Animation>
    </div>
  );
};

MsLoader.propTypes = {
  size: PropTypes.number,
  theme: PropTypes.object,
  color: PropTypes.string,
};

MsLoader.defaultProps = {
  size: 24,
  theme: {},
  color: '',
};

export default withTheme(MsLoader);
